<template>
  <section class="navtab">
    <slot />
  </section>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.navtab {
  scroll-margin-top: 80px;
  padding-top: variables.$fs-l;
  margin-bottom: variables.$fs-l;
}
@media (min-width: 768px) {
  .navtab {
    padding-top: variables.$fs-md-l;
    margin-bottom: variables.$fs-md-l;
  }
}
</style>
